angular.module('bmsApp.directives').factory('ActivitySvc', [
	'$q',
	'$rootScope',
	'$modal',
	'notify',
	'CRUDSvc',
	'ACTIVITY_API', function (
		$q,
		$rootScope,
		$modal,
		notify,
		CRUDSvc,
		ACTIVITY_API) {

	return {
		showSaveModal: function (activity) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/crm/activity/templates/ActivitySaveModal.html',
				controller: 'ActivityModalFormCtrl',
				size: 'lg',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					activity: function () {
						return angular.copy(activity);
					}
				}
			});

			modalInstance.result.then(function (result) {
				if (result.success === true) {
					var message;
					switch (result.action) {
						case 'create':
							message = 'Activity created successfully';
							break;
						case 'update':
							message = 'Activity updated successfully';
							break;
						default:
							message = 'Success';
							break;
					}
					notify({
						message: message
					});
				}
				else {
					notify({
						message: result.error,
						classes: 'error'
					});
				}
			}, function () {
				// closed
			});

			return modalInstance.result;
		},

		create: function (activity) {
			var activityCopy = angular.copy(activity);
			if (angular.isObject(activityCopy.activity_start_date)) {
				activityCopy.activity_start_date = activityCopy.activity_start_date.format('YYYY-MM-DD HH:mm:ss');
			}
			if (angular.isObject(activityCopy.activity_end_date)) {
				activityCopy.activity_end_date = activityCopy.activity_end_date.format('YYYY-MM-DD HH:mm:ss');
			}
			return CRUDSvc.post(ACTIVITY_API.CREATE, activityCopy);
		},
		update: function (activity) {
			var activityCopy = angular.copy(activity);
			if (angular.isObject(activityCopy.activity_start_date)) {
				activityCopy.activity_start_date = activityCopy.activity_start_date.format('YYYY-MM-DD HH:mm:ss');
			}
			if (angular.isObject(activityCopy.activity_end_date)) {
				activityCopy.activity_end_date = activityCopy.activity_end_date.format('YYYY-MM-DD HH:mm:ss');
			}
			return CRUDSvc.post(ACTIVITY_API.UPDATE + activityCopy.id, activityCopy);
		},
		calendarEvents: function (params) {
			return CRUDSvc.get(ACTIVITY_API.CALENDAR_EVENTS, params);
		},
		upcoming: function (params) {
			return CRUDSvc.get(ACTIVITY_API.UPCOMING, params);
		},
		scheduleDurationTypeOptions: function () {
			var deferred = $q.defer();

			// spoof response
			var response = {
				data: {
					success:true,
					message:'',
					options: [
						{
							value:'minutes',
							label:'Minutes'
						},
						{
							value:'hours',
							label:'Hours'
						},
						{
							value:'days',
							label:'Days'
						},
						{
							value:'weeks',
							label:'Weeks'
						}
					]
				}
			};

			deferred.resolve(response);

			return deferred.promise;
		},
		reoccurenceTypeOptions: function () {
			var deferred = $q.defer();

			// spoof response
			var response = {
				data: {
					success:true,
					message:'',
					options: [
						{
							value:'Does not repeat',
							label:'Does not repeat'
						},
						{
							value:'Daily',
							label:'Daily'
						},
						{
							value:'Weekly',
							label:'Weekly'
						},
						{
							value:'Four Weekly',
							label:'Four Weekly'
						},
						{
							value:'Monthly',
							label:'Monthly'
						}
					]
				}
			};

			deferred.resolve(response);

			return deferred.promise;
		},
		delete: function (params) {
			return CRUDSvc.post(ACTIVITY_API.DELETE, params);
		},
		status: {
			options: function () {
				return CRUDSvc.get('api/activityStatus/options');
			}
		}
	};

}]).constant('ACTIVITY_API', {
	CREATE: 'api/activity/create',
	UPDATE: 'api/activity/update/',
	CALENDAR_EVENTS: 'api/activity/calendarEvents',
	UPCOMING: 'api/activity/upcoming',
	DELETE: 'api/activity/delete'
});
